import { render, staticRenderFns } from "./ChoosePerformer.vue?vue&type=template&id=dfc9908a&"
import script from "./ChoosePerformer.vue?vue&type=script&lang=js&"
export * from "./ChoosePerformer.vue?vue&type=script&lang=js&"
import style0 from "./ChoosePerformer.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports